exports = module.exports = require("../../../../../../table-showoff/node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".HorizontalDivider__HorizontalDivider__yL4pJ {\n  border-top: 0.5px solid #DDDDDD;\n}", ""]);

// exports
exports.locals = {
	"HorizontalDivider": "HorizontalDivider__HorizontalDivider__yL4pJ"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"modules":true,"localIdentName":"[name]__[local]__[hash:base64:5]"}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!../shared-components/src/components/UI/Divider/HorizontalDivider/HorizontalDivider.css
// module id = 463
// module chunks = 0